import React from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../components/ui/Icon";
import usePageTheme from "../utils/usePageTheme";
import "../Social.css";

// The social page (clubs, posts and events) is being rebuilt. Until then we show a friendly placeholder.
const Social = () => {
    usePageTheme("lake");
    const navigate = useNavigate();

    return (
        <div className="page page--narrow">
            <div className="card coming-soon">
                <div className="coming-soon__art" aria-hidden="true">
                    <span className="coming-soon__sign">
                        <Icon name="sprout" size={22}/>
                        Under construction
                    </span>
                </div>
                <div className="coming-soon__body">
                    <div className="eyebrow">Social</div>
                    <h1>Coming soon</h1>
                    <p>
                        We are building a new social section with clubs, posts and events.
                        It is not quite ready yet, so check back soon!
                    </p>
                    <ul className="coming-soon__list">
                        <li><Icon name="users"/> Clubs with their own lobby and leaderboard</li>
                        <li><Icon name="calendar"/> Events and tournaments with friends</li>
                        <li><Icon name="chat"/> Posts and conversations with the community</li>
                    </ul>
                    <div className="row row--wrap" style={{marginTop: "1.25rem"}}>
                        <button className="btn btn-primary" onClick={() => navigate("/")}>
                            <Icon name="board"/> Play a game
                        </button>
                        <button className="btn" onClick={() => navigate("/my-profile")}>
                            <Icon name="users"/> Find your friends
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Social;
